import { ApiIsometricIcon } from '../icons/ApiIsometricIcon';
import { DocsIsometricIcon } from '../icons/DocsIsometricIcon';
import { StorybookIsometricIcon } from '../icons/StorybookIsometricIcon';
import { UsersIsometricIcon } from '../icons/UsersIsometricIcon';

const documentationLinks = [
  {
    url: `/docs/default/component/dx-documentation-public/landing-page-guide/getting-started/`,
    label: 'Getting Started Guide',
  },
  {
    url: `/docs/default/component/dx-documentation-public/landing-page-guide/`,
    label: 'Landing Page Guide',
  },
  {
    url: `/docs/default/component/dx-documentation-public/api-catalog/accesstoken/`,
    label: 'API Catalog',
  },
  {
    url: `/docs/default/component/dx-documentation-public/RELEASE_NOTES/`,
    label: 'API Release Notes',
  },
];

export const homeCards = {
  firstColumn: [
    {
      title: 'APIs',
      description:
        '“APIs“ provides a preview for registered APIs with endpoints test capabilities if configured and documentations if available per API. The preview provides basic filtering and search, and links to GitHub repository. APIs creation and management is available in GitHub only with corresponding permissions.',
      icon: ApiIsometricIcon,
      href: '/api-docs',
    },
    {
      title: 'Storybook',
      description:
        '“Storybook” is a collection of reusable UI components that allows developers and non-technical people to see and test how components behave. All possible actions one can take are available under the Controls menu and are intuitively understandable. All changes appear in real time in the preview screen.',
      icon: StorybookIsometricIcon,
      href: '/storybook',
    },
    {
      title: 'User Management',
      description:
        '“Users” provides capabilities to User onboarding and management. This provides User creation, Roles and Permissions assignment, Teams creation and management.',
      icon: UsersIsometricIcon,
      href: '/user-management',
    },
  ],
  secondColumn: [
    {
      title: 'Documentation',
      description:
        '“APIs“ provides a preview for registered APIs with endpoints test capabilities if configured and documentations if available per API. The preview provides basic filtering and search, and links to GitHub repository. APIs creation and management is available in GitHub only with corresponding permissions.',
      icon: DocsIsometricIcon,
      links: documentationLinks,
    },
  ],
};
